'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('./Utils');

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var valueMapper = function valueMapper(item) {
    return item.value;
};

var MultipleSelect = function (_Component) {
    _inherits(MultipleSelect, _Component);

    function MultipleSelect() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MultipleSelect);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultipleSelect.__proto__ || Object.getPrototypeOf(MultipleSelect)).call.apply(_ref, [this].concat(args))), _this), _this._updateValue = function (data) {
            var option = _this.props.options.find(function (item) {
                return item.value === data[_this.props.name];
            });

            // If user presses backspace, the Select component will send a 'null' as the selected value
            // (as backspace means "clear the selection" to the Select component). As such, it should be
            // safe to just ignore it. So let's check that what came back was a proper object.
            if (Object(option) === option) {
                if (_this.props.values.map(valueMapper).includes(option.value)) {
                    _this._removeOption(option);
                } else {
                    _this.props.updateValue(_defineProperty({}, _this.props.name, [].concat(_toConsumableArray(_this.props.values), [option])));
                }
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * Add or remove a value to the currently-selected values.
     *
     * @param {Object} data - The data on which option was selected.
     *
     * @returns {void}
     */


    _createClass(MultipleSelect, [{
        key: '_removeOption',


        /**
         * Remove the given option from our selected options.
         *
         * @param {Object} option - The option to be removed.
         *
         * @returns {void}
         */
        value: function _removeOption(option) {
            this.props.updateValue(_defineProperty({}, this.props.name, this.props.values.filter(function (item) {
                return item.value !== option.value;
            })));
        }

        /**
         * Get the options to pass into the composed Seelct component, but preformat the options first.
         *
         * @returns {Object[]} The list of options.
         */

    }, {
        key: '_getFormattedOptions',
        value: function _getFormattedOptions() {
            var values = this.props.values.map(valueMapper);

            return this.props.options.map(function (item) {
                // If our values contain the option in question, then create a rich label from the
                // plain label that indicates that it is selected, and also add the focused class to the
                // containing div.
                if (values.includes(item.value)) {
                    return _extends({}, item, {
                        richLabel: item.richLabel ? _react2.default.createElement(item.richLabel, { selected: true }) : _react2.default.createElement(
                            'span',
                            null,
                            '✓ ',
                            item.label
                        ),
                        classes: (item.classes || '') + ' control-select__option--focused'
                    });
                }

                // If the option is not selected, just return it as-is
                return item;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var groupClasses = (0, _classnames2.default)({
                'form__group': true,
                'form__group--error': this.props.errors && this.props.errors.length
            });

            var selectedItems = null;

            if (this.props.values.length && this.props.displaySelections) {
                selectedItems = this.props.values.map(function (option) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'tag', key: option.value },
                        option.label,
                        ' ',
                        _react2.default.createElement(
                            'a',
                            {
                                className: 'tag__clear',
                                onClick: _this2._removeOption.bind(_this2, option)
                            },
                            '×'
                        )
                    );
                });
            }

            return _react2.default.createElement(
                'div',
                { className: groupClasses },
                _react2.default.createElement(
                    'div',
                    { className: this.props.className },
                    _react2.default.createElement(_Select2.default, {
                        closeOnSelect: false,
                        defaultOptions: this.props.defaultOptions,
                        disabled: this.props.disabled,
                        error: this.props.error,
                        getFilteredOptions: this.props.getFilteredOptions,
                        handleBlur: this.props.handleBlur,
                        handleFocus: this.props.handleFocus,
                        help: this.props.help,
                        label: this.props.label,
                        minCharSearch: this.props.minCharSearch,
                        name: this.props.name,
                        noOptionPlaceholder: this.props.noOptionPlaceholder,
                        noResultsPlaceholder: this.props.noResultsPlaceholder,
                        options: this._getFormattedOptions(),
                        placeholder: this.props.placeholder,
                        searchOptions: this.props.searchOptions,
                        searchingPlaceholder: this.props.searchingPlaceholder,
                        type: this.props.type,
                        updateValue: this._updateValue,
                        value: this.props.values.map(valueMapper)
                    }),
                    selectedItems
                )
            );
        }
    }]);

    return MultipleSelect;
}(_react.Component);

MultipleSelect.propTypes = _extends({}, _Utils.formControlPropTypes, _Utils.focussablePropTypes, _Utils.hasOptionsPropTypes, {

    categoriseBy: _propTypes2.default.string,
    className: _propTypes2.default.string,
    defaultOptions: _propTypes2.default.array,
    displaySelections: _propTypes2.default.bool,
    getFilteredOptions: _propTypes2.default.func,
    minCharSearch: _propTypes2.default.number,
    noOptionPlaceholder: _propTypes2.default.string,
    noResultsPlaceholder: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    searchOptions: _propTypes2.default.func,
    searchingPlaceholder: _propTypes2.default.string,
    type: _propTypes2.default.string,
    value: function value() {},
    values: _propTypes2.default.arrayOf(_propTypes2.default.any)
});
MultipleSelect.defaultProps = {
    disabled: false,
    displaySelections: true,
    values: []
};
exports.default = MultipleSelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@matyas/matyaskar-forked-react-ui/lib/MultipleSelect.js
// module id = 396
// module chunks = 0